import { render, staticRenderFns } from "./facet-search-card.vue?vue&type=template&id=56aeb22a&scoped=true&"
import script from "./facet-search-card.ts?vue&type=script&lang=ts&"
export * from "./facet-search-card.ts?vue&type=script&lang=ts&"
import style0 from "./facet-search-card.scss?vue&type=style&index=0&id=56aeb22a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aeb22a",
  null
  
)

export default component.exports